import { z } from "zod";
import { ShortText, idString } from "./common.js";
/**
 * PB-4923 added `id`, optional only so pre-backfill rows still validate.
 *
 * The period `label` is NOT the identity, though it looks like one. It is
 * user-editable, so a rename would read as a delete plus an add — losing a
 * concurrent edit to that point's value — and because a removal leaves a
 * tombstone under its key, deleting "Wk 1" would permanently block ever
 * creating a point called "Wk 1" again. A minted id has neither problem: a
 * rename is an ordinary field edit that keeps the point's identity and its
 * revision, and a re-created point is simply a new point.
 */
const RunChartPoint = z
    .object({
    id: idString.optional(),
    label: ShortText,
    value: z.number().finite(),
})
    .strict();
/** The published params shape before PB-4923 added point ids. */
export const RetiredRunChartParamsV1Schema = z
    .object({
    title: ShortText.optional(),
    unit: ShortText.optional(),
    target: z.number().finite().optional(),
    points: z
        .array(z.object({ label: ShortText, value: z.number().finite() }).strict())
        .max(500),
})
    .strict();
/**
 * Run Chart — Specify, multi. Time-series of a single metric. Editor
 * supports CSV/XLSX upload + column mapping; on-canvas card shows the
 * latest value + delta + a line chart with optional target reference.
 */
export const RunChartParamsSchema = z
    .object({
    title: ShortText.optional(),
    unit: ShortText.optional(),
    target: z.number().finite().optional(),
    points: z.array(RunChartPoint).max(500),
})
    .strict();
export const defaultRunChartParams = {
    unit: "",
    points: [],
};
//# sourceMappingURL=runChart.js.map